<template>
  <div
    class="parent"
    v-lazy:background-image="{
      src: bg,
    }"
  >
    <title-widge
      :title="title"
      :subTitle="subTitle"
      :titleColor="titleColor"
      :subTitleColor="subTitleColor"
    ></title-widge>
    <div class="divContent">
      <img
        v-lazy="{
          src: bgUrl,
          loading: require('./../../../../../assets/wheelplanting.jpg'),
        }"
      />
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "",
    },
    subTitleColor: {
      type: String,
      default: "rgba(255,255,255,1)",
    },
    bgUrl: {
      //图片
      type: String,
      default: "",
    },
    bg: {
      //背景图
      type: String,
      default: "",
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./../scss/functionWidge.scss";
</style>
